import { render } from "./FinnStatistics.vue?vue&type=template&id=778681e0&scoped=true"
import script from "./FinnStatistics.vue?vue&type=script&lang=js"
export * from "./FinnStatistics.vue?vue&type=script&lang=js"

import "./FinnStatistics.vue?vue&type=style&index=0&id=778681e0&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778681e0"]])

export default __exports__